import { oidcConfig } from './okta-config'

const defaultRedirection = process.env.REACT_APP_DEFAULT_REDIRECTION
const salesforceBaseUrl = process.env.REACT_APP_SALESFORCE_BASE_URL

const reactRoutes: any = {
  home: '/',
  welcome: '/welcome',
  login: '/login',
  loginCallback: '/implicit/callback', // This is where auth is handled after redirection
  gatewayCallback: '/gateway/callback',
  impersonate: '/impersonate',
  impersonateGateway: '/impersonateGateway',
  passwordExpired: '/password-expired',
  mfa: '/mfa',
  membershipExpired: '/membership-expired',
  subscriptionAgreement: '/subscription-agreement',
  forgotLoginName: '/forgot-login-name',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  changePassword: '/change-password',
  logout: '/logout',
  noAccess: '/no-access',
  expirePassword: '/expire-password',
  enroll: '/enroll',
  updateEnrollment: '/update-enrollment',
  updateEnrollmentOtpForm: '/update-enrollment-otp-form',
  passwordSecurity: '/password-and-security',
}

const reDirections: any = {
  defaultRedirection,
  BCOM: {
    needHelp: `${defaultRedirection}/article/8431`,
    login: `${defaultRedirection}/login`,
    join: `${defaultRedirection}/join`,
    noAccess: `${defaultRedirection}/messaging/no-access-to-application`,
    home: `${defaultRedirection}/home`,
    dashboard: `${defaultRedirection}/dashboard`,
  },
  oktaLogout: (idToken: string, redirectUri: string) =>
    `${oidcConfig.issuer}/v1/logout?id_token_hint=${idToken}&post_logout_redirect_uri=${redirectUri}`,
  inactiveMemberRedirection: `${salesforceBaseUrl}/customers/apex/Communities_Inactives?id=`,
}

const routesConfig: any = {
  ...reactRoutes,
  ...reDirections,
}

export default routesConfig
